import React, { useState } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import DirectionsBusFilledIcon from '@mui/icons-material/DirectionsBusFilled';
import CommuteIcon from '@mui/icons-material/Commute';
import EstimateForm from './EstimateForm';
import { ESTIMATE_TYPES } from '../../const/estimateOptions';

const TABS = [
  {
    value: ESTIMATE_TYPES.GENERAL,
    label: '일반 버스대절 견적',
    caption: '관광·워크숍·행사',
    color: '#E8112D',
    icon: <DirectionsBusFilledIcon />,
  },
  {
    value: ESTIMATE_TYPES.COMMUTE,
    label: '통근·셔틀버스 견적',
    caption: '출퇴근·정기운행',
    color: '#1B3C7A',
    icon: <CommuteIcon />,
  },
];

/**
 * 견적 요청 영역. 상단 탭으로 일반 버스대절 / 통근·셔틀버스 견적을 전환한다.
 * PC·모바일 공통 컴포넌트이며 입력 항목도 동일하다.
 */
export default function EstimateSection() {
  const [estimateType, setEstimateType] = useState(ESTIMATE_TYPES.GENERAL);
  const current = TABS.find((tab) => tab.value === estimateType) ?? TABS[0];

  return (
    <Paper
      elevation={8}
      sx={{
        width: '100%',
        maxWidth: 900,
        mx: 'auto',
        my: { xs: 2, md: 4 },
        borderRadius: '20px',
        overflow: 'hidden',
        backgroundColor: '#FFFACB',
      }}
    >
      {/* 견적 종류 탭 */}
      <Stack direction='row' sx={{ backgroundColor: '#efe9df' }}>
        {TABS.map((tab) => {
          const selected = tab.value === estimateType;
          return (
            <Box
              key={tab.value}
              role='tab'
              aria-selected={selected}
              onClick={() => setEstimateType(tab.value)}
              sx={{
                flex: 1,
                cursor: 'pointer',
                textAlign: 'center',
                minWidth: 0,
                px: { xs: 0.5, md: 2 },
                py: { xs: 1.4, md: 2 },
                backgroundColor: selected ? tab.color : 'transparent',
                color: selected ? '#fff' : '#8a7c6d',
                transition: 'background-color .18s ease, color .18s ease',
                borderBottom: selected ? 'none' : '3px solid transparent',
                '&:hover': { backgroundColor: selected ? tab.color : 'rgba(0,0,0,0.05)' },
              }}
            >
              <Stack direction='row' spacing={0.8} justifyContent='center' alignItems='center'>
                {React.cloneElement(tab.icon, {
                  /* 좁은 화면에선 아이콘 자리 때문에 탭 글자가 잘린다 */
                  sx: {
                    display: { xs: 'none', sm: 'block' },
                    fontSize: { xs: 20, md: 24 },
                    color: selected ? '#fff' : '#a99a89',
                  },
                })}
                <Typography
                  component='span'
                  sx={{
                    fontSize: { xs: 13.5, md: 18 },
                    fontWeight: 800,
                    letterSpacing: '-0.01em',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {tab.label}
                </Typography>
              </Stack>
              <Typography
                sx={{
                  mt: 0.3,
                  fontSize: { xs: 11, md: 12.5 },
                  color: selected ? 'rgba(255,255,255,0.85)' : '#a99a89',
                }}
              >
                {tab.caption}
              </Typography>
            </Box>
          );
        })}
      </Stack>

      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Typography
          component='h2'
          sx={{
            p: '12px',
            mb: 3,
            borderRadius: '10px',
            backgroundColor: current.color,
            color: '#FCFCFC',
            textAlign: 'center',
            fontSize: { xs: 16, md: 19 },
            fontWeight: 800,
          }}
        >
          {estimateType === ESTIMATE_TYPES.GENERAL
            ? '실시간 버스대절 견적요청'
            : '통근·셔틀버스 견적요청'}
        </Typography>

        <EstimateForm key={estimateType} estimateType={estimateType} accentColor={current.color} />
      </Box>
    </Paper>
  );
}
